import { Stack, Typography } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'

type Props = {
  sourcing: string | null
  companyName: string
}

const SourcingTab: React.FC<Props> = ({ sourcing, companyName }) => {
  const { t } = useTranslation()
  return (
    <Stack spacing={3} direction="column">
      <Stack direction="column">
        <Typography variant="subtitle3">
          {sourcing ? t('cc:Sourcing') : t('cc:dialogTabs.noSourcingInfo')}
        </Typography>
        {sourcing ? (
          <Typography color="text.secondary" variant="body3">
            ({t('cc:allInformationProvidedBy')} {companyName})
          </Typography>
        ) : null}
      </Stack>
      {sourcing ? (
        <Stack>
          <Typography variant="subtitle3">{t('cc:ingredientSources')}</Typography>
          <Typography variant="body2">{sourcing}</Typography>
        </Stack>
      ) : (
        <Typography variant="body2">
          {t('cc:dialogTabs.waitingForInfo', { companyName })}
        </Typography>
      )}
    </Stack>
  )
}

export default SourcingTab
